import ImageWithLoader from "./ImageWithLoader";

export default ImageWithLoader;
